import { render } from "./AffordabilityOfTransportation.vue?vue&type=template&id=2371f4a7"
import script from "./AffordabilityOfTransportation.vue?vue&type=script&lang=js"
export * from "./AffordabilityOfTransportation.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__